import Tab from "react-bootstrap/Tab";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import Tabs from "react-bootstrap/Tabs";
import Cookies from "js-cookie";
import Moment from "react-moment";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { fetchPedigree } from "../../redux/getReducer/getPedigree";
import {
  fetchSingleHorse,
  STATUSES,
} from "../../redux/getReducer/getSingleHorse";
import { useDispatch, useSelector } from "react-redux";
import DefaultImg from "../../assets/Frame.png";
import { useTranslation } from "react-i18next";
import PleaseWait from "../Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VideoFrame from "./VideoFrame";
import { fetchHorseRecord } from "../../redux/getReducer/getHorseRecord";
import { fetchhorsehistory } from "../../redux/getReducer/getHorseHistory";
import { fetchHorseFutureEntries } from "../../redux/getReducer/getFutureEntries";
import HorseStats from "../Tabs/HorseStats";
import OwnerDetail from "./OwnerModal";
import TrainerDetail from "./TrainerModal";
import BeatenByModal from "./HorseModal";
import JockeyDetail from "./JockeyModal";
import RaceModal from "./RaceModal";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import Pagination from "../../pages/Pagination";
import ScrollContainer from "react-indiana-drag-scroll";
import { IoMdPlay } from "react-icons/io";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";


import { getBaseUrl } from "../../service/apiUrl";
const HorseDetail = (data) => {
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => {
    setmodaldatas(data);
    await setShows(true);
  };

  const { data: Pedigree } = useSelector((state) => state.Pedigree);
  const { data: horsehistory, status: historyStatus } = useSelector((state) => state.horsehistory);
  const { data: horserecord } = useSelector((state) => state.horserecord);
  const { data: singlehorse, status } = useSelector(
    (state) => state.singlehorse
  );
  const { data: fututreentries } = useSelector((state) => state.fututreentries);

  const [TrackStatus, SetTrackStatus] = useState(false);
  const [ShowOwner, setShowOwner] = useState(false);
  const [modaldatasowner, setmodaldatasowner] = useState();
  const handleOwnerCloses = () => setShowOwner(false);
  const handleShowOwner = (data) => { const id = data?._id || data; if (id) navigate("/owner-detail?" + id); };

  const [ShowTrainer, setShowTrainer] = useState(false);
  const [modaldatasTrainer, setmodaldatasTrainer] = useState();
  const handleTrainerCloses = () => setShowTrainer(false);
  const handleShowTrainer = (data) => { const id = data?._id || data; if (id) navigate("/trainer-detail?" + id); };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const handleHorseCloses = () => setShowHorse(false);
  const handleShowHorse = (data) => { const id = data?._id || data; if (id) navigate("/horse-detail?" + id); };

  const [ShowJockey, setShowJockey] = useState(false);
  const [modaldatasJockey, setmodaldatasJockey] = useState();
  const handleJockeyCloses = () => setShowJockey(false);
  const handleShowJockey = (data) => {
    const id = data?._id || data;
    if (id) navigate("/jockey-detail?" + id);
  };

  const sortedHorseRecord = useMemo(() => {
    if (!Array.isArray(horsehistory)) return [];
    return [...horsehistory].sort((a, b) => {
      const aDay = new Date(a?.RaceResultData?.StartTime || a?.RaceResultData?.Day || a?.Day || 0).getTime();
      const bDay = new Date(b?.RaceResultData?.StartTime || b?.RaceResultData?.Day || b?.Day || 0).getTime();
      return bDay - aDay;
    });
  }, [horsehistory]);

  let totalcountdata = sortedHorseRecord.length;
  const [postsPerPage] = useState(11);
  const totalpagesdata = Math.ceil(totalcountdata / postsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const firstPageIndex = (currentPage - 1) * postsPerPage;
  const lastPageIndex = firstPageIndex + postsPerPage;
  const SliceData = sortedHorseRecord.slice(firstPageIndex, lastPageIndex);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const navigate = useNavigate();
  const btnNew1 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "13px 10px",
    gap: "10px",
    width: "112px",
    height: "24px",
    background: "#FF0000",
    borderRadius: "10px",
    border: "none",
    color: "#fff",
    margin: "10px 27px",
  };
  const btnNew2 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "13px 10px",
    gap: "10px",
    width: "112px",
    height: "24px",
    background: "#0388fc",
    borderRadius: "10px",
    border: "none",
    color: "#fff",
    margin: "6px",
  };
  const token = Cookies.get("token");
  const handleUnTrack = async (Id) => {
    try {
      await axios.post(
        `${getBaseUrl()}/UnTrackHorse`,
        { Horse: Id },
        {
          headers: { Authorization: token, "x-xsrf-token": token },
        }
      );
      toast("Horse Has Been UnTracked ");
      navigate("/tracker/#Horseshome");
      // dispatch(fetchSingleHorse({ Id }));
      // navigate("/tracker");
    } catch (error) {
      const err = error.response.data.message;
      toast(err);
    }
  };

  const handleTrack = async (Id) => {
    try {
      await axios.post(
        `${getBaseUrl()}/trackhorse`,
        { Horse: Id },
        {
          headers: { Authorization: token, "x-xsrf-token": token },
        }
      );
      // toast("Tracked Success");

      navigate("/tracker/#Horseshome");
    } catch (error) {
      const err = error.response.data.message;
      if (err === "Json Web Token is invalid") {
        toast.error("Please Login to Access This Resourse");
        navigate("/login");
      } else {
        toast.error(err);
      }
    }
  };

  const id = data.data?.HorseModelIdData1
    ? (data.data.HorseModelIdData1._id || data.data.HorseModelIdData1)
    : data.data?._id
      ? data.data._id
      : (data.data?.HorseID || data.data);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPedigree({ id }));
    dispatch(fetchHorseRecord({ id }));
    dispatch(fetchSingleHorse({ id }));
    dispatch(fetchHorseFutureEntries({ id }));
    dispatch(fetchhorsehistory({ id }));
  }, [dispatch, id]);
  function calculatePercentage(x, y) {
    if (y === 0) return "0";
    const answer = (x / y) * 100;
    return Math.round(answer);
  }

  function formatAMPM(date) {
    if (!date) return "-";
    const datenow = new Date(date);
    if (isNaN(datenow.getTime())) return "-";
    var hours = datenow.getHours();
    var minutes = datenow.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  function distanceLabel(distance, rank) {
    const DistanceTobeChecked = parseFloat(distance);

    if (DistanceTobeChecked.toFixed(2) > 25) {
      return "Dist";
    } else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) {
      return "SHd";
    } else if (DistanceTobeChecked.toFixed(2) == 0.1 && rank < 80) {
      return "Hd";
    } else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) {
      return "Nk";
    } else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) {
      return "Ns";
    } else if (DistanceTobeChecked.toFixed(2) == 0.0 && rank < 80) {
      if (rank === 1) {
        return 0;
      }
      return "Dh";
    } else {
      return distance;
    }
  }
  function calculateAge(dateOfBirth) {
    var dob = new Date(dateOfBirth);
    var today = new Date();

    var yearsDiff = today.getFullYear() - dob.getFullYear();
    var monthsDiff = today.getMonth() - dob.getMonth();
    var daysDiff = today.getDate() - dob.getDate();

    // Check if the current month and day are before the birth month and day
    if (monthsDiff < 0 || (monthsDiff === 0 && daysDiff < 0)) {
      yearsDiff--;
    }

    return yearsDiff;
  }
  return (
    <>
      {status === "loading" ? (
        <>
          <Lottie animationData={Animate} loop={true} className="TableLottie" />
        </>
      ) : (
        <div className="RaceDetailCard">
          {singlehorse && (
            <>
              {/* Top Modal Card */}
              <div className="new-horse-modal-header-container">

                {/* --- SECTION 1: LEFT (Silk & Mini Stats) --- */}
                <div className="new-header-col-left">
                  <div className="new-silk-shirt-wrap">
                    <img
                      src={!data.data.CapColorData1 ? DefaultImg : data.data.CapColorData1.OwnerSilkColor}
                      alt="Silk"
                      className="new-silk-image"
                    />
                  </div>
                  <div className="new-mini-stats-row-hidden" style={{ display: 'none' }}>
                    {/* These are moved to the center col now */}
                  </div>
                </div>

                {/* --- SECTION 2: CENTER (Identity & Details) --- */}
                <div className="new-header-col-center">
                  {/* Row 1: Title */}
                  <div className="new-horse-header-title">
                    {cookiedata === "en" ? window.textTransform(singlehorse.NameEn) : singlehorse.NameAr}
                    {' '}({cookiedata === "en" ? singlehorse.NationalityData?.AbbrevEn : singlehorse.NationalityData?.AbbrevAr})
                    {' '}{calculateAge(singlehorse.DOB)} {t("yrs")}.
                    {' '}{cookiedata === "en" ? singlehorse.SexModelData?.AbbrevEn : singlehorse.SexModelData?.AbbrevAr}
                    {' '}{singlehorse.CapColorData1 ? (cookiedata === "en" ? window.textTransform(singlehorse.CapColorData1.NameEn).charAt(0) : singlehorse.CapColorData1.NameAr?.charAt(0)) : ""}
                    {(data.data?.HorseNo || data.data?.GateNo) ? ` (${data.data.HorseNo || data.data.GateNo})` : ""}
                  </div>

                  {/* Combined Top Info Grid: 6 Columns (Dam, Sire, GSire, PM, BTO, SP) */}
                  <div className="new-horse-top-info-grid">
                    <div className="info-col">
                      <span className="info-label">{t("Dam")}</span>
                      <span className="info-value">
                        {cookiedata === "en" ? toTitleCase(singlehorse?.DamData?.NameEn) : singlehorse?.DamData?.NameAr || "-"}
                      </span>
                    </div>
                    <div className="info-col">
                      <span className="info-label">{t("Sire")}</span>
                      <span className="info-value">
                        {cookiedata === "en" ? toTitleCase(singlehorse?.SireData?.NameEn) : singlehorse?.SireData?.NameAr || "-"}
                      </span>
                    </div>
                    <div className="info-col">
                      <span className="info-label">{t("GSire")}</span>
                      <span className="info-value">
                        {cookiedata === "en" ? toTitleCase(singlehorse?.GSireData?.NameEn) : singlehorse?.GSireData?.NameAr || "-"}
                      </span>
                    </div>
                    <div className="info-col is-stat">
                      <span className="info-label">{t("PM")}</span>
                      <span className="info-value">{Math.round(singlehorse?.TotalPrizeWin || 0).toLocaleString()}</span>
                    </div>
                    <div className="info-col is-stat">
                      <span className="info-label">{t("BTO")}</span>
                      <span className="info-value">{Math.round(singlehorse?.TotalBto || 0).toLocaleString()}</span>
                    </div>
                    <div className="info-col is-stat">
                      <span className="info-label">{t("SP")}</span>
                      <span className="info-value">{Math.round(singlehorse?.PurchasePrice || 0).toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Row 3: Contacts & Rating */}
                  <div className="new-contacts-stats-layout">
                    <div className="new-contact-grid">
                      <div className="owner-name" onClick={() => handleShowOwner(singlehorse.ActiveOwnerData)}>
                        O: {cookiedata === "en" ? toTitleCase(singlehorse.ActiveOwnerData?.NameEn) : singlehorse.ActiveOwnerData?.NameAr}
                      </div>
                      <div className="owner-stats">
                        {singlehorse.ActiveOwnerData?.OwnerCount}&nbsp;({singlehorse.ActiveOwnerData?.OwnerFirstRanking}-{singlehorse.ActiveOwnerData?.OwnerSecondRanking}-{singlehorse.ActiveOwnerData?.OwnerThirdRanking})
                      </div>

                      <div className="trainer-name" onClick={() => handleShowTrainer(singlehorse.ActiveTrainerData)}>
                        T: {cookiedata === "en" ? toTitleCase(singlehorse.ActiveTrainerData?.NameEn) : singlehorse.ActiveTrainerData?.NameAr}
                      </div>
                      <div className="trainer-stats">
                        {singlehorse.ActiveTrainerData?.TrainerCount}&nbsp;({singlehorse.ActiveTrainerData?.TrainerFirstRanking}-{singlehorse.ActiveTrainerData?.TrainerSecondRanking}-{singlehorse.ActiveTrainerData?.TrainerThirdRanking})
                      </div>

                      <div className="breeder-name">
                        B: {cookiedata === "en" ? toTitleCase(singlehorse.BreederData?.NameEn) : singlehorse.BreederData?.NameAr || "Unknown"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* --- SECTION 3: RIGHT (Logo & Action) --- */}
                <div className="new-horse-modal-col-right">
                  <div className="new-horse-modal-logo-container">
                    <img src={singlehorse.HorseImage || DefaultImg} alt="Horse Logo" className="new-horse-modal-logo-img" />
                  </div>
                  <div className="new-horse-modal-btn-wrap" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <div className="new-rating-badge-side" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                      <span className="rating-label" style={{ fontSize: '24px', color: '#64748b', fontWeight: '700' }}>{t("Rating")}</span>
                      <span className="rating-value" style={{ fontSize: '24px', fontWeight: '900', color: '#1a73e8', lineHeight: '1' }}>{singlehorse?.mostRecentRating ?? singlehorse?.Rating ?? "-"}</span>
                    </div>
                    {singlehorse.track === true ? (
                      <button className="new-horse-modal-btn-black" onClick={() => handleUnTrack(singlehorse._id)}>{t("Untrack")}</button>
                    ) : (
                      <button className="new-horse-modal-btn-red" onClick={() => handleTrack(singlehorse._id)}>{t("Track")}</button>
                    )}
                  </div>
                </div>

              </div>

              {/* <div className="row" style={{margin:"10px"}}>
                 <div className="col-sm-12 pmclass">
                 <p>
                   {t("PM")} :
                   <b>
                     {data
                       ? data
                           .TotalPrizeWin
                       : 0}
                   </b>
                 </p>
                 <p>
                   {t("BTO")} :
                   <b>
                     {data ? (
                       data.TotalBto
                     ) : (
                       <> 0</>
                     )}
                   </b>
                 </p>
                 <p>
                   {t("SP")}{" "}
                   <b>
                     {data ? (
                       data.PurchasePrice
                     ) : (
                       <> 0</>
                     )}
                   </b>
                 </p>
               </div>
              </div>
              */}
            </>
          )}

          {/* Form & Pedigree */}
          <div className="new-horse-modal-body">
            <div style={{ marginTop: '20px', marginBottom: '30px' }}>
              {/* --- FORM SECTION HEADER --- */}
            <div className="new-horse-modal-form-title-row">
              <h2 className="new-horse-modal-section-heading">{t("FORM")}</h2>
              <span className="new-horse-modal-history-value">
                {singlehorse.HorseForm && singlehorse.HorseForm}
              </span>
            </div>

            {/* --- LIFETIME RECORD TABLE (DIV GRID BASE) --- */}
            <div className="new-horse-modal-grid-table">
              {/* Table Header: 9 Columns mapped */}
              <div className="new-horse-modal-lifetime-thead">
                <div>{t("Lifetime Record")}</div>
                <div>{t("Runs")}</div>
                <div>{t("Wins")}</div>
                <div>{t("2nd")}</div>
                <div>{t("3rd")}</div>
                <div>{t("4th")}</div>
                <div>{t("5th")}</div>
                <div>{t("Winnings")}</div>
                <div>{t("Earnings")}</div>
              </div>

              {/* Table Body rows mapping individual logic */}
              <div className="new-horse-modal-grid-tbody">
                {/* ROW 1: TURF */}
                <div className="new-horse-modal-lifetime-row">
                  <div className="new-bold">{t("Turf")}</div>
                  <div>{singlehorse.TurfCount}</div>
                  <div>{singlehorse.TurfWins === null ? 0 : singlehorse.TurfWins}</div>
                  <div>{singlehorse.Turfsecond === null ? 0 : singlehorse.Turfsecond}</div>
                  <div>{singlehorse.Turfthird === null ? 0 : singlehorse.Turfthird}</div>
                  <div>{singlehorse.Turffourth === null ? 0 : singlehorse.Turffourth}</div>
                  <div>{singlehorse.Turffifth === null ? 0 : singlehorse.Turffifth}</div>
                  <div>{calculatePercentage((singlehorse.Turfsecond || 0) + (singlehorse.TurfWins || 0) + (singlehorse.Turfthird || 0), singlehorse.TurfCount)}%</div>
                  <div>{Math.round(singlehorse.TurfEarnings || 0).toLocaleString()} AED</div>
                </div>

                {/* ROW 2: DIRT */}
                <div className="new-horse-modal-lifetime-row">
                  <div className="new-bold">{t("Dirt")}</div>
                  <div>{singlehorse.DirtCount}</div>
                  <div>{singlehorse.DirtWins === null ? 0 : singlehorse.DirtWins}</div>
                  <div>{singlehorse.Dirtsecond === null ? 0 : singlehorse.Dirtsecond}</div>
                  <div>{singlehorse.Dirtthird === null ? 0 : singlehorse.Dirtthird}</div>
                  <div>{singlehorse.Dirtfourth === null ? 0 : singlehorse.Dirtfourth}</div>
                  <div>{singlehorse.Dirtfifth === null ? 0 : singlehorse.Dirtfifth}</div>
                  <div>{calculatePercentage((singlehorse.Dirtsecond || 0) + (singlehorse.DirtWins || 0) + (singlehorse.Dirtthird || 0), singlehorse.DirtCount)}%</div>
                  <div>{Math.round(singlehorse.DirtEarnings || 0).toLocaleString()} {t("AED")}</div>
                </div>

                {/* ROW 3: ALL WEATHER */}
                <div className="new-horse-modal-lifetime-row">
                  <div className="new-bold">{t("All Weather")}</div>
                  <div>{singlehorse.AllWeatherCount}</div>
                  <div>{singlehorse.AllWeatherWins === null ? 0 : singlehorse.AllWeatherWins}</div>
                  <div>{singlehorse.AllWeathersecond === null ? 0 : singlehorse.AllWeathersecond}</div>
                  <div>{singlehorse.AllWeatherthird === null ? 0 : singlehorse.AllWeatherthird}</div>
                  <div>{singlehorse.AllWeatherfourth === null ? 0 : singlehorse.AllWeatherfourth}</div>
                  <div>{singlehorse.AllWeatherfifth === null ? 0 : singlehorse.AllWeatherfifth}</div>
                  <div>{calculatePercentage((singlehorse.AllWeathersecond || 0) + (singlehorse.AllWeatherWins || 0) + (singlehorse.AllWeatherthird || 0), singlehorse.AllWeatherCount)}%</div>
                  <div>{Math.round(singlehorse.AllWeatherEarnings || 0).toLocaleString()} {t("AED")}</div>
                </div>

                {/* ROW 4: TOTAL (HIGHLIGHTED ROW) */}
                <div className="new-horse-modal-lifetime-row new-total-row">
                  <div className="new-bold">{t("Total")}</div>
                  <div className="new-bold">{singlehorse.TotalCount}</div>
                  <div className="new-bold">{singlehorse.TotalWins === null ? 0 : singlehorse.TotalWins}</div>
                  <div className="new-bold">{singlehorse.Totalsecond === null ? 0 : singlehorse.Totalsecond}</div>
                  <div className="new-bold">{singlehorse.Totalthird === null ? 0 : singlehorse.Totalthird}</div>
                  <div className="new-bold">{singlehorse.Totalfourth === null ? 0 : singlehorse.Totalfourth}</div>
                  <div className="new-bold">{singlehorse.Totalfifth === null ? 0 : singlehorse.Totalfifth}</div>
                  <div className="new-bold">{calculatePercentage((singlehorse.Totalsecond || 0) + (singlehorse.TotalWins || 0) + (singlehorse.Totalthird || 0), singlehorse.TotalCount)}%</div>
                  <div className="new-bold">{Math.round(singlehorse.TotalEarnings || 0).toLocaleString()} {t("AED")}</div>
                </div>
              </div>
            </div>

            </div>

            {/* --- PEDIGREE SECTION --- */}
            <div className="new-horse-modal-pedigree-wrapper">
              <h2 className="new-horse-modal-section-heading" style={{ marginBottom: '20px' }}>{t("PEDIGREE")}</h2>
              {!Pedigree || Pedigree.length === 0 ? (
                <div className="new-horse-modal-no-results-box">
                  <div className="new-watermark-icon"></div>
                  <p>{t("No Results Available")}</p>
                </div>
              ) : (
                <div className="new-horse-modal-tree-main">

                  {/* Column 1: Generation 1 (2 Boxes) */}
                  <div className="new-horse-modal-gen-col">
                    <div className="new-pedigree-box-1 new-bg-blue">
                      {Pedigree.generation1?.SireData ? (cookiedata === "en" ? Pedigree.generation1.SireData.NameEn : Pedigree.generation1.SireData.NameAr) : "-"}
                    </div>
                    <div className="new-pedigree-box-1 new-bg-pink">
                      {Pedigree.generation1?.DamData ? (cookiedata === "en" ? Pedigree.generation1.DamData.NameEn : Pedigree.generation1.DamData.NameAr) : "-"}
                    </div>
                  </div>

                  {/* Column 2: Generation 2 (4 Boxes) */}
                  <div className="new-horse-modal-gen-col">
                    <div className="new-pedigree-box-1 new-bg-blue">
                      {Pedigree.generation2b?.SireData ? (cookiedata === "en" ? Pedigree.generation2b.SireData.NameEn : Pedigree.generation2b.SireData.NameAr) : "-"}
                    </div>
                    <div className="new-pedigree-box-1 new-bg-pink">
                      {Pedigree.generation2b?.DamData ? (cookiedata === "en" ? Pedigree.generation2b.DamData.NameEn : Pedigree.generation2b.DamData.NameAr) : "-"}
                    </div>
                    <div className="new-pedigree-box-1 new-bg-blue">
                      {Pedigree.generation2a?.SireData ? (cookiedata === "en" ? Pedigree.generation2a.SireData.NameEn : Pedigree.generation2a.SireData.NameAr) : "-"}
                    </div>
                    <div className="new-pedigree-box-1 new-bg-pink">
                      {Pedigree.generation2a?.DamData ? (cookiedata === "en" ? Pedigree.generation2a.DamData.NameEn : Pedigree.generation2a.DamData.NameAr) : "-"}
                    </div>
                  </div>

                  {/* Column 3: Generation 3 (8 Boxes) */}
                  <div className="new-horse-modal-gen-col">
                    {[Pedigree.generation3d, Pedigree.generation3c, Pedigree.generation3b, Pedigree.generation3a].map((gen, idx) => (
                      <Fragment key={idx}>
                        <div className="new-pedigree-box-1 new-bg-blue">
                          {gen?.SireData ? (cookiedata === "en" ? gen.SireData.NameEn : gen.SireData.NameAr) : "-"}
                        </div>
                        <div className="new-pedigree-box-1 new-bg-pink">
                          {gen?.DamData ? (cookiedata === "en" ? gen.DamData.NameEn : gen.DamData.NameAr) : "-"}
                        </div>
                      </Fragment>
                    ))}
                  </div>

                </div>
              )}
            </div>
          </div>

          <div className="new-horse-modal-tabs-section">
            <Tabs id="horse-modal-tabs" className="new-horse-modal-styled-tabs mb-4" defaultActiveKey="Form">

              {/* --- 1. FORM TAB --- */}
              <Tab eventKey="Form" title={t("Form")}>
                <div className="new-horse-modal-tab-content">
                  <ScrollContainer className="new-horse-modal-scroll">
                    <div className="new-horse-modal-grid-table">
                      {/* Div Header (16 Columns) */}
                      <div className="new-horse-modal-grid-thead">
                        <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Dist")}</div>
                        <div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div>
                        <div>{t("Wgt")}</div><div>{t("Speed")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div>
                        <div>{t("BtBy")}</div><div>{t("W Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div></div>
                      </div>

                      {/* Body Mapping */}
                      <div className="new-horse-modal-grid-tbody">
                        {(!horsehistory || historyStatus === "loading") ? (
                          <div className="text-center py-4"><PleaseWait /></div>
                        ) : (!SliceData || SliceData.length === 0) ? (
                          <div className="text-center py-4"><p style={{ color: "#888", fontSize: "16px" }}>{t("No Results Available")}</p></div>
                        ) : SliceData.map((item, i) => {
                          const ground = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                          const rowBg = ground === "Turf" ? "#d4edda" : ground === "Dirt" ? "#f2e6d9" : "#f1f5f9";

                          const getRecordName = (record) => {
                            if (!record) return "";
                            if (cookiedata === "en") {
                              return toTitleCase(record?.NameEn || record?.ShortNameEn || "");
                            }
                            return record?.NameAr || record?.ShortNameAr || "";
                          };
                          const getRecordId = (record) => record?._id || record?.id || (typeof record === 'string' ? record : null);

                          // 1. Current / active connections from horse profile or racecard props
                          const activeTrainerRecord = data?.data?.TrainerOnRaceData1 || singlehorse?.ActiveTrainerData;
                          const activeOwnerRecord = data?.data?.OwnerIdData || singlehorse?.ActiveOwnerData;

                          // Check if active/upcoming trainer differs from the horse's most recent run (shown before row 0)
                          let topTrainerChangeMsg = null;
                          let topOwnerChangeMsg = null;
                          if (i === 0 && currentPage === 1) {
                            const activeTrName = getRecordName(activeTrainerRecord);
                            const pastTrName = getRecordName(item?.TrainerOnRaceDataResult);
                            const activeTrId = getRecordId(activeTrainerRecord);
                            const pastTrId = getRecordId(item?.TrainerOnRaceDataResult);
                            const isTrDiff = (activeTrId && pastTrId && activeTrId !== pastTrId) ||
                              (activeTrName && pastTrName && activeTrName.toLowerCase() !== pastTrName.toLowerCase());

                            if (isTrDiff && activeTrName && pastTrName) {
                              topTrainerChangeMsg = cookiedata === "en"
                                ? <>Trainer changed from <strong>{pastTrName}</strong> to <strong>{activeTrName}</strong></>
                                : <>تغير المدرب من <strong>{pastTrName}</strong> إلى <strong>{activeTrName}</strong></>;
                            }

                            const activeOwName = getRecordName(activeOwnerRecord);
                            const pastOwName = getRecordName(item?.OwnerIdData);
                            const activeOwId = getRecordId(activeOwnerRecord);
                            const pastOwId = getRecordId(item?.OwnerIdData);
                            const isOwDiff = (activeOwId && pastOwId && activeOwId !== pastOwId) ||
                              (activeOwName && pastOwName && activeOwName.toLowerCase() !== pastOwName.toLowerCase());

                            if (isOwDiff && activeOwName && pastOwName) {
                              topOwnerChangeMsg = cookiedata === "en"
                                ? <>Owner changed from <strong>{pastOwName}</strong> to <strong>{activeOwName}</strong></>
                                : <>تغير المالك من <strong>{pastOwName}</strong> إلى <strong>{activeOwName}</strong></>;
                            }
                          }

                          // 2. Change between past runs (item vs newerRace)
                          const globalIdx = firstPageIndex + i;
                          const newerRace = globalIdx > 0 ? sortedHorseRecord[globalIdx - 1] : null;
                          let rowTrainerChangeMsg = null;
                          let rowOwnerChangeMsg = null;

                          if (newerRace) {
                            const newerTrName = getRecordName(newerRace?.TrainerOnRaceDataResult);
                            const currTrName = getRecordName(item?.TrainerOnRaceDataResult);
                            const newerTrId = getRecordId(newerRace?.TrainerOnRaceDataResult);
                            const currTrId = getRecordId(item?.TrainerOnRaceDataResult);
                            const trDiff = (newerTrId && currTrId && newerTrId !== currTrId) ||
                              (newerTrName && currTrName && newerTrName.toLowerCase() !== currTrName.toLowerCase());

                            if (trDiff && currTrName && newerTrName) {
                              rowTrainerChangeMsg = cookiedata === "en"
                                ? <>Trainer changed from <strong>{currTrName}</strong> to <strong>{newerTrName}</strong></>
                                : <>تغير المدرب من <strong>{currTrName}</strong> إلى <strong>{newerTrName}</strong></>;
                            }

                            const newerOwName = getRecordName(newerRace?.OwnerIdData);
                            const currOwName = getRecordName(item?.OwnerIdData);
                            const newerOwId = getRecordId(newerRace?.OwnerIdData);
                            const currOwId = getRecordId(item?.OwnerIdData);
                            const owDiff = (newerOwId && currOwId && newerOwId !== currOwId) ||
                              (newerOwName && currOwName && newerOwName.toLowerCase() !== currOwName.toLowerCase());

                            if (owDiff && currOwName && newerOwName) {
                              rowOwnerChangeMsg = cookiedata === "en"
                                ? <>Owner changed from <strong>{currOwName}</strong> to <strong>{newerOwName}</strong></>
                                : <>تغير المالك من <strong>{currOwName}</strong> إلى <strong>{newerOwName}</strong></>;
                            }
                          }

                          return (
                            <Fragment key={i}>
                              {i === 0 && !!topOwnerChangeMsg && (
                                <div className="new-horse-modal-change-row new-horse-modal-change-pill-owner">
                                  <span>{topOwnerChangeMsg}</span>
                                </div>
                              )}
                              {i === 0 && !!topTrainerChangeMsg && (
                                <div className="new-horse-modal-change-row new-horse-modal-change-pill-trainer">
                                  <span>{topTrainerChangeMsg}</span>
                                </div>
                              )}
                              {!!rowOwnerChangeMsg && (
                                <div className="new-horse-modal-change-row new-horse-modal-change-pill-owner">
                                  <span>{rowOwnerChangeMsg}</span>
                                </div>
                              )}
                              {!!rowTrainerChangeMsg && (
                                <div className="new-horse-modal-change-row new-horse-modal-change-pill-trainer">
                                  <span>{rowTrainerChangeMsg}</span>
                                </div>
                              )}
                              <div className="new-horse-modal-grid-row" style={{ backgroundColor: rowBg, color: '#333' }}>
                                <div onClick={() => {
                                  handleShowRace(item.RaceID);
                                  navigate(`/race-detail?${item.RaceID}`);
                                }} className="new-clickable-white">
                                  <Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime || item.RaceResultData?.Day}</Moment>
                                </div>
                                <div>
                                  {cookiedata === "en" ? item.RaceResultData?.RaceCourseData?.AbbrevEn : item.RaceResultData?.RaceCourseData?.AbbrevAr}
                                  ({cookiedata === "en" ? ground?.charAt(0) : item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})
                                </div>
                                <div>{item.RaceResultData?.TrackLengthData?.TrackLength}</div>
                                <div className="new-horse-modal-truncate">{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}</div>
                                <div>{item.RaceTime || item.RaceResultData?.RaceTime || "-"}</div>
                                <div
                                  onClick={() =>
                                    item.JockeyOnRaceDataResult?._id &&
                                    handleShowJockey(item.JockeyOnRaceDataResult?._id)
                                  }
                                  className={item.JockeyOnRaceDataResult?._id ? "new-clickable-white" : ""}
                                >
                                  {cookiedata === "en"
                                    ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn || item.JockeyOnRaceDataResult?.NameEn)
                                    : item.JockeyOnRaceDataResult?.NameAr}
                                </div>
                                <div>{item.HorseWeight ?? "-"}</div>
                                <div>{typeof item.Speed === "number" ? item.Speed.toFixed(2) : "-"}</div>
                                <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
                                <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                                <div>{item.RaceResultData?.Runners}</div>
                                {(() => {
                                  const rank = item?.FinalPositionDataHorse?.Rank;
                                  // Client requirement for Horse Detail:
                                  // Rank 1 (Winner): show Runner-Up (2nd place horse)
                                  // Rank > 1 (Rank 2, 3, 4, ...): show Winner (1st place horse)
                                  const targetHorse = rank === 1
                                    ? (item?.RunnerUpData || item?.BeatenByData || null)
                                    : (item?.WinnerData || item?.BeatenByData || null);

                                  const targetName = targetHorse
                                    ? (cookiedata === "en" ? toTitleCase(targetHorse.NameEn || "") : (targetHorse.NameAr || targetHorse.NameEn || "-"))
                                    : (cookiedata === "en"
                                        ? toTitleCase(item?.HorseIDData?.HorseBeatenByEnglishName || "")
                                        : (item?.HorseIDData?.HorseBeatenByArabicName || item?.HorseIDData?.HorseBeatenByEnglishName || "-"));

                                  const targetId = targetHorse?._id || item?.BeatenByData?._id;
                                  const targetWeight = targetHorse?.WinningHorseJockeyWeight ?? item?.BeatenByData?.WinningHorseJockeyWeight ?? item?.HorseIDData?.BeatenByJockeyWeight ?? 0;

                                  return (
                                    <Fragment>
                                      <div
                                        className={`new-horse-modal-truncate ${targetId ? "new-clickable-white" : ""}`}
                                        title={targetName || ""}
                                        onClick={() => targetId && handleShowHorse(targetId)}
                                        style={{ cursor: targetId ? "pointer" : "default" }}
                                      >
                                        {targetName || "-"}
                                      </div>
                                      <div>{targetWeight}</div>
                                    </Fragment>
                                  );
                                })()}
                                <div>{item.RaceResultData?.Draw || "-"}</div>
                                <div>{item.Rating || 0}</div>
                                <div onClick={() => handleShows(item.VideoLink)} className="new-horse-modal-mini-play"><IoMdPlay /></div>
                              </div>
                            </Fragment>
                          );
                        })}
                      </div>
                    </div>
                  </ScrollContainer>
                  <div className="new-horse-modal-pagination-box">
                    <Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} />
                  </div>
                </div>
              </Tab>

              {/* --- 2. ENTRIES TAB --- */}
              <Tab eventKey="Entries" title={t("Entries")}>
                <div className="new-horse-modal-tab-content">
                  <ScrollContainer className="new-horse-modal-scroll">
                    <div className="new-horse-modal-grid-table">
                      <div className="new-entries-horse-modal-grid-thead">
                        <div>{t("Date")}</div>
                        <div>{t("Crs")}</div>
                        <div>{t("TC")}</div>
                        <div>{t("RT")}</div>
                        <div>{t("Time")}</div>
                        <div>{t("Jockey")}</div>
                        <div>{t("Len")}</div>
                        <div>{t("RN")}</div>
                        <div>{t("Kgs")}</div>
                        <div>{t("Draw")}</div>
                        <div>{t("OR")}</div>
                      </div>
                      <div className="new-horse-modal-grid-tbody">
                        {fututreentries === undefined ? (
                          <div className="text-center py-4"><PleaseWait /></div>
                        ) : (!fututreentries || fututreentries.length === 0) ? (
                          <div className="text-center py-4"><p style={{ color: "#888", fontSize: "16px" }}>{t("No Entries Available")}</p></div>
                        ) : (
                          fututreentries.map((item, i) => {
                            const ground = item.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                            const rowBg = ground === "Dirt" ? "#f2e6d9" : ground === "Turf" ? "#d4edda" : "#f1f5f9";

                            return (
                              <div key={i} className="new-entries-horse-modal-grid-row" style={{ backgroundColor: rowBg, color: '#333' }}>
                                <div onClick={() => {
                                  handleShowRace(item.RacehorsesData?._id);
                                  navigate(`/race-detail?${item.RacehorsesData?._id}`);
                                }} className="new-clickable-link">
                                  <Moment format="DD/MM/YYYY">{item.RacehorsesData?.Day || item.RaceResultData?.Day || item.RacehorsesData?.StartTime}</Moment>
                                </div>
                                <div>
                                  {cookiedata === "en" ? item.RacehorsesData?.RaceCourseData?.AbbrevEn : item.RacehorsesData?.RaceCourseData?.AbbrevAr}
                                  ({cookiedata === "en" ? ground?.charAt(0) : item.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr?.charAt(0)})
                                </div>
                                <div>{cookiedata === "en" ? item.RacehorsesData?.TrackConditionData?.NameEn : item.RacehorsesData?.TrackConditionData?.NameAr}</div>

                                {/* RT Column */}
                                <div>
                                  {cookiedata === "en" ? toTitleCase(truncateRaceType(item.RacehorsesData?.RaceTypeModelData?.NameEn)) : item.RacehorsesData?.RaceTypeModelData?.NameAr}
                                </div>

                                <div><Moment format="hh:mm A">{item.RacehorsesData?.Day || item.RaceResultData?.Day || item.RacehorsesData?.StartTime}</Moment></div>
                                <div onClick={() => handleShowJockey(item.JockeyOnRaceData1?._id)} className="new-clickable-link">
                                  {cookiedata === "en" ? toTitleCase(item.JockeyOnRaceData1?.ShortNameEn) : item.JockeyOnRaceData1?.ShortNameAr}
                                </div>
                                <div>{item.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                                <div>{item.Runners}</div>
                                <div>{item.JockeyRaceWeight}</div>
                                <div>{item.GateNo || "-"}</div>
                                <div>{item.Rating || 0}</div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </ScrollContainer>
                </div>
              </Tab>

              {/* --- 3. STATS TAB --- */}
              <Tab eventKey="Stats" title={t("Stats")}>
                <div className="new-horse-modal-stats-wrapper">
                  <HorseStats id={id} />
                </div>
              </Tab>
            </Tabs>
          </div>

          <Modal
            show={shows}
            onHide={handleCloses}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <VideoFrame data={modaldatas} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>

          <Modal
            show={ShowOwner}
            onHide={handleOwnerCloses}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <OwnerDetail data={modaldatasowner} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>

          <Modal
            show={ShowTrainer}
            onHide={handleTrainerCloses}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <TrainerDetail data={modaldatasTrainer} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>

          <Modal
            show={ShowHorse}
            onHide={handleHorseCloses}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <BeatenByModal data={modaldatasHorse} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>

          <Modal
            show={ShowJockey}
            onHide={handleJockeyCloses}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <JockeyDetail data={modaldatasJockey} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
          <Modal
            show={showRace}
            onHide={handleCloseRace}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="popupheader" closeButton></Modal.Header>
            <Modal.Body>
              <RaceModal id={modaldataRace} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};
export default HorseDetail;
